import React from 'react';
import { LogoIcon } from './LogoIcon';
export function Footer() {
  return <footer className="relative bg-gradient-to-b from-apple-light to-gray-100 pt-16 pb-8 px-4 sm:px-6 lg:px-8" data-id="element-123" data-mp="3gf94guwt048f">
      {/* Gradient top border */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent" data-id="element-124" data-mp="32p5m4f11ouo9" />

      <div className="max-w-7xl mx-auto" data-id="element-125" data-mp="36nd4feb5q41k">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-8" data-id="element-126" data-mp="3ueiltxwqx4dz">
          <div className="flex items-center gap-3" data-id="element-127" data-mp="38h81hlebwon">
            <LogoIcon size={32} data-id="element-128" data-mp="37xxily2sakn" />
            <span className="text-sm font-bold text-apple-black tracking-tight" data-id="element-129" data-mp="3lec768pb9yd8">
              nexify-studio.tech
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm text-apple-gray" data-id="element-130" data-mp="3qc3z32pyhkhf">
            <a href="https://cloud-sparkle-nexus.lovable.app" target="_blank" rel="noopener noreferrer" className="font-semibold hover:text-apple-blue transition-colors duration-300" data-id="element-131" data-mp="29ydxc2mb78ay">
              ☁️ Cloud NS/AI
            </a>
            <a href="#engine" className="hover:text-apple-black transition-colors duration-300" data-id="element-132" data-mp="3gbqyeggtmnbf">
              Engine
            </a>
            <a href="#pwa" className="hover:text-apple-black transition-colors duration-300" data-id="element-133" data-mp="3q8djn6d27gdz">
              PWA
            </a>
            <a href="#portfolio" className="hover:text-apple-black transition-colors duration-300" data-id="element-134" data-mp="33xe1y3atysi">
              Portfólio
            </a>
            <a href="#kontakt" className="hover:text-apple-black transition-colors duration-300" data-id="element-135" data-mp="huwh6tld7v4p">
              Kontakt
            </a>
          </div>
        </div>

        <div className="h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-8" data-id="element-136" data-mp="qr5ikdswl3th" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-apple-gray" data-id="element-137" data-mp="mq3hrsjc8jpe">
          <p data-id="element-138" data-mp="yu7j4w3bzy0b">
            Copyright © 2026 nexify-studio.tech. Všetky práva
            vyhradené.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-139" data-mp="13sr4aua3p5rm">
            <a href="#" className="hover:text-apple-black transition-colors duration-300" data-id="element-140" data-mp="13rg39281ic47">
              Ochrana Súkromia
            </a>
            <a href="#" className="hover:text-apple-black transition-colors duration-300" data-id="element-141" data-mp="1clch7tr1wi8j">
              Podmienky Používania
            </a>
            <a href="#" className="hover:text-apple-black transition-colors duration-300" data-id="element-142" data-mp="1mkbk0vp4xjnm">
              Mapa Stránky
            </a>
          </div>
        </div>
      </div>
    </footer>;
}